(function () {
  if (customElements.get('gilgal-bought-together')) return;

  class GilgalBoughtTogether extends HTMLElement {
    connectedCallback() {
      this._productId = this.dataset.productId;
      this._limit = parseInt(this.dataset.limit) || 3;
      this._fetch();
    }

    async _fetch() {
      try {
        const url =
          '/recommendations/products.json?product_id=' +
          this._productId +
          '&limit=' +
          this._limit +
          '&intent=related';
        const r = await fetch(url);
        const data = await r.json();
        if (data.products && data.products.length > 0) {
          this._render(data.products);
        } else {
          this.style.display = 'none';
        }
      } catch (e) {
        this.style.display = 'none';
      }
    }

    _render(products) {
      const container = this.querySelector('.gilgal-bought-together__products');
      const footer = this.querySelector('.gilgal-bought-together__footer');
      const loading = this.querySelector('.gilgal-bought-together__loading');

      container.innerHTML = products
        .map((p) => {
          const v = p.variants[0];
          const price = (v.price / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });
          const fi = p.featured_image;
          const rawSrc = fi
            ? (typeof fi === 'string' ? fi : (fi.src || ''))
            : '';
          const imgSrc = rawSrc ? rawSrc + (rawSrc.includes('?') ? '&' : '?') + 'width=80' : '';
          const imgTag = imgSrc
            ? '<img src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">'
            : '<div class="gilgal-bt-item__img-placeholder" aria-hidden="true"></div>';
          return (
            '<label class="gilgal-bt-item">' +
            '<input type="checkbox" value="' +
            v.id +
            '" data-price="' +
            v.price +
            '" checked>' +
            '<div class="gilgal-bt-item__inner">' +
            imgTag +
            '<div class="gilgal-bt-item__info">' +
            '<span class="gilgal-bt-item__name">' +
            p.title +
            '</span>' +
            '<span class="gilgal-bt-item__price">' +
            price +
            '</span>' +
            '</div></div></label>'
          );
        })
        .join('');

      loading.style.display = 'none';
      container.style.display = 'flex';
      footer.style.display = 'block';
      this._updateBtn();
      container.addEventListener('change', () => this._updateBtn());
    }

    _updateBtn() {
      const checked = Array.from(
        this.querySelectorAll('input[type=checkbox]:checked')
      );
      const btn = this.querySelector('.gilgal-bought-together__add');
      if (checked.length === 0) {
        btn.setAttribute('disabled', '');
        return;
      }
      btn.removeAttribute('disabled');
      btn.addEventListener('click', () => this._addToCart(checked), {
        once: true,
      });
    }

    async _addToCart(inputs) {
      const items = inputs.map((i) => ({ id: parseInt(i.value), quantity: 1 }));
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      window.location.href = '/cart';
    }
  }

  customElements.define('gilgal-bought-together', GilgalBoughtTogether);
})();
